/**
 * BusinessProcess Validation Schemas
 */

import { z } from 'zod';
import { nameField, optionalBoundedText, requiredIdField } from './shared';

export const createBusinessProcessSchema = z.object({
  name: nameField(200, 'Name is required', 'Name must be 200 characters or less'),
  description: optionalBoundedText(2000),
  processType: z.enum(['core', 'supporting', 'management'], {
    message: 'Process type is required',
  }),
  processTier: z.enum(['strategic', 'operational', 'tactical'], {
    message: 'Process tier is required',
  }),
  processOwnerId: requiredIdField('Process owner is required'),
  owningBusinessUnitId: requiredIdField('Owning business unit is required'),
  inputDescription: optionalBoundedText(2000),
  outputDescription: optionalBoundedText(2000),
  estimatedDuration: optionalBoundedText(200),
  volumePerPeriod: optionalBoundedText(200),
  automationLevel: z.enum(['manual', 'semi-automated', 'automated', 'autonomous']).optional(),
  toolingDescription: optionalBoundedText(2000),
  status: z.enum(['draft', 'active', 'deprecated', 'retired']).optional(),
  tags: z.array(z.string().min(1)).optional().default([]),
  notes: optionalBoundedText(5000),
});

export type CreateBusinessProcessFormData = z.infer<typeof createBusinessProcessSchema>;
